module.exports = __webpack_public_path__ + "static/ShopGold-a89e8f5e9f04aa5d746e0c63e8c70621.svg";